import { AnalyticsEvent } from './types';

export class Queue {
  private queue: AnalyticsEvent[];

  constructor() {
    this.queue = [];
  }

  enqueue(item: AnalyticsEvent) {
    this.queue.push(item);
  }

  dequeue() {
    return this.queue.shift();
  }

  isEmpty() {
    return this.queue.length === 0;
  }

  size() {
    return this.queue.length;
  }

  clear() {
    this.queue = [];
  }

  peek() {
    return this.queue[0];
  }
}
